import React, { useEffect, useState } from 'react';
import { adminApi } from '../../api/client';
import Modal from '../../components/common/Modal';
import Spinner from '../../components/common/Spinner';
import { FaPlus, FaCheck } from 'react-icons/fa';
import toast from 'react-hot-toast';

export default function Terms() {
  const [terms,   setTerms]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal,   setModal]   = useState(false);
  const [form,    setForm]    = useState({ year: new Date().getFullYear(), term_number: 1, name: '', start_date: '', end_date: '', is_current: false });

  const load = () => adminApi.getTerms().then(r => setTerms(r.data.data)).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    try { await adminApi.addTerm({ ...form, is_current: form.is_current ? 1 : 0 }); toast.success('Term added'); setModal(false); load(); }
    catch (err) { toast.error(err.response?.data?.message || 'Failed'); }
  };

  const setCurrent = async (term) => {
    try { await adminApi.updateTerm({ term_id: term.term_id, name: term.name, start_date: term.start_date, end_date: term.end_date, is_current: 1 }); toast.success('Current term updated'); load(); }
    catch { toast.error('Failed'); }
  };

  return (
    <div>
      <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div><h2>Academic Terms</h2><p>Manage school terms and academic years</p></div>
        <button className="sms-btn sms-btn-primary" onClick={() => { setForm({ year: new Date().getFullYear(), term_number: 1, name: '', start_date: '', end_date: '', is_current: false }); setModal(true); }}>
          <FaPlus size={13} /> Add Term
        </button>
      </div>

      <div className="sms-card" style={{ padding: 0, overflow: 'hidden' }}>
        {loading ? <Spinner /> : (
          <table className="sms-table">
            <thead><tr><th>Term</th><th>Year</th><th>Start</th><th>End</th><th>Status</th><th>Action</th></tr></thead>
            <tbody>
              {terms.map(t => (
                <tr key={t.term_id}>
                  <td style={{ fontWeight: 500 }}>{t.name || `Term ${t.term_number}`}</td>
                  <td>{t.year}</td>
                  <td>{t.start_date || '—'}</td>
                  <td>{t.end_date || '—'}</td>
                  <td>{t.is_current ? <span className="sms-badge badge-present">Current</span> : <span className="sms-badge" style={{ background: '#f3f4f6', color: '#6b7280' }}>Inactive</span>}</td>
                  <td>{!t.is_current && <button className="sms-btn sms-btn-outline sms-btn-sm" onClick={() => setCurrent(t)}><FaCheck size={11} /> Set Current</button>}</td>
                </tr>
              ))}
              {terms.length === 0 && <tr><td colSpan="6" style={{ textAlign: 'center', color: '#9ca3af', padding: '40px 0' }}>No terms added</td></tr>}
            </tbody>
          </table>
        )}
      </div>

      <Modal show={modal} onClose={() => setModal(false)} title="Add Term">
        <form onSubmit={handleSave}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 14 }}>
            <div><label className="sms-label">Year</label><input className="sms-input" type="number" value={form.year} onChange={e => setForm({ ...form, year: e.target.value })} required /></div>
            <div><label className="sms-label">Term Number</label><input className="sms-input" type="number" min="1" max="4" value={form.term_number} onChange={e => setForm({ ...form, term_number: e.target.value })} required /></div>
            <div><label className="sms-label">Term Name</label><input className="sms-input" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="e.g. Term 1" /></div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, paddingTop: 22 }}>
              <input type="checkbox" id="current" checked={form.is_current} onChange={e => setForm({ ...form, is_current: e.target.checked })} />
              <label htmlFor="current">Set as current term</label>
            </div>
            <div><label className="sms-label">Start Date</label><input className="sms-input" type="date" value={form.start_date} onChange={e => setForm({ ...form, start_date: e.target.value })} /></div>
            <div><label className="sms-label">End Date</label><input className="sms-input" type="date" value={form.end_date} onChange={e => setForm({ ...form, end_date: e.target.value })} /></div>
          </div>
          <div style={{ display: 'flex', gap: 10 }}>
            <button type="submit" className="sms-btn sms-btn-primary">Save</button>
            <button type="button" className="sms-btn sms-btn-outline" onClick={() => setModal(false)}>Cancel</button>
          </div>
        </form>
      </Modal>
    </div>
  );
}
